import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=58fdd289&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import "./Upload.vue?vue&type=style&index=0&id=58fdd289&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdd289",
  null
  
)

export default component.exports